import httpClient from "@/api/httpClient";
import CompanyPage from "@/model/CompanyPage";
import CompanyRegistrationRequest from "@/model/CompanyRegistrationRequest";
import CompanyUpdateRequest from "@/model/CompanyUpdateRequest";
import CompanyResponse from "@/model/CompanyResponse";

function listCompanies(
  accessToken: string,
  page: number,
  size: number
): Promise<CompanyPage> {
  return httpClient.getJson<CompanyPage>(
    `/api/companies?page=${page}&size=${size}`,
    accessToken
  );
}

function getCompanyById(
  accessToken: string,
  id: string
): Promise<CompanyResponse> {
  return httpClient.getJson<CompanyResponse>(
    `/api/companies/${id}`,
    accessToken
  );
}

function createCompany(
  accessToken: string,
  request: CompanyRegistrationRequest
): Promise<CompanyResponse> {
  return httpClient.postJson<CompanyResponse>(
    "/api/companies",
    request,
    accessToken
  );
}

function updateCompany(
  accessToken: string,
  id: string,
  request: CompanyUpdateRequest
): Promise<CompanyResponse> {
  return httpClient.patchJson<CompanyResponse>(
    `/api/companies/${id}`,
    request,
    accessToken
  );
}

function addUserToCompany(
  accessToken: string,
  companyId: string,
  userId: string
): Promise<CompanyResponse> {
  return httpClient.putJson<CompanyResponse>(
    `/api/companies/${companyId}/users/${userId}`,
    accessToken
  );
}

function removeUserFromCompany(
  accessToken: string,
  companyId: string,
  userId: string
): Promise<CompanyResponse> {
  return httpClient.deleteJson<CompanyResponse>(
    `/api/companies/${companyId}/users/${userId}`,
    accessToken
  );
}

const companiesApi = {
  listCompanies,
  getCompanyById,
  createCompany,
  updateCompany,
  addUserToCompany,
  removeUserFromCompany,
};

export default companiesApi;
